export const gitCommit = 'cbb18515'
